import {getShortenedName, hideContent, makeGameRequest, runFuseElementsSearch} from "./ui-helpers.js";
import {disabledMenuButtonHandler, resetMenuButtonClickHandlers} from "./game-menu.js";
import {playSoundEffect} from "./sounds.js";
import {globals, globalUser} from "../modules/globals.js";
import {commaSeparate, getCurrentGame, shuffle} from "../modules/helpers.js";
import {
    addBrandDraftPick,
    addUserDraftPick,
    endBrandDraftTurn,
    endDraftTurn,
    getDraftSuperstarInfo, simulateDraftPicks, skipBrandDraftTurn
} from "../modules/draft.js";
import {showSuperstarInformation} from "./booking.js";
import {loadHomePage} from "./home-page.js";

let showRandomPickAnimation = true;

function showDraftPage(draftData) {
    // Show draft info
    let draftInfoContent = getDraftInfoHtml(draftData);
    $('.draft-info-content').html(draftInfoContent);
    $('.draft-name-label').text(draftData['name']);

    $('#booking-container').find('.participants-box-match-header, .participants-box-segment-header, ' +
        '.participants-box-match-container, .participants-box-callup-header, .participants-box-segment-container, ' +
        '#add-segment, #booking-talent-menu, #booking-championship-info, .participants-box-trade-offer-header, ' +
        '#booking-talent-container').hide();
    $('#booking-container').find('.participants-box-draft-header').show();
    hideContent($('.draft-info-container'));
    $('.main-menu-container').find('li').removeClass('selected');
    $("#main-menu-right").html('');

    // Disable menu buttons
    resetMenuButtonClickHandlers(disabledMenuButtonHandler);

    // Show draft results
    $('.continue-to-draft-button').off('click');
    $('.continue-to-draft-button').on('click', function () {
        playSoundEffect('success');
        showDraftResults(draftData);
    });
}

function getDraftInfoHtml(draftData) {
    let infoTextArray;
    if (draftData['isBrandDraft']) {
        if (draftData['type'] === 'full') {
            infoTextArray = ['All superstars are removed from their current brands',
                'Draft ends when all brands have ended their turns',
                'Championships will move alongside their champions',
                'Undrafted superstars will become available on all brands',
                'Overness will reset for all brands']
        }
        else {
            infoTextArray = ['Brands can pick from all superstars belonging to other brands or not assigned to a brand',
                'Remaining superstars will stay on their current brands',
                'Championships will move alongside their champions']
        }
    } else {
        if (draftData['type'] === 'user_only') {
            let availableSuperstarsInfo;
            if (draftData['settings']['includeCompanyRosters'] && draftData['settings']['includeIndies']) {
                availableSuperstarsInfo = 'Superstars from all Companies and the Indies are eligible'
            }
            else if (draftData['settings']['includeCompanyRosters']) {
                availableSuperstarsInfo = 'Superstars from all Companies are eligible'
            }
            else if (draftData['settings']['includeIndies']) {
                availableSuperstarsInfo = 'Superstars from the Indies are eligible'
            }
            infoTextArray = [availableSuperstarsInfo, 'You are required to draft a minimum of 10 Superstars',
                'Draft ends when no more Superstars are available or you click on \'End Draft\'',
            'Drafted Superstars are removed from their factions, managers and brands, and their championships are vacated']
        }
        else {
            infoTextArray = ['Superstars from all main Rosters are eligible', 'First draft selection is chosen at random',
                'You are required to draft a minimum of 10 Superstars',
                'Draft ends when no more Superstars are available or you click on \'End Draft\'',
                'Any Superstars not picked will be sent to the Indies', 'All Championships will be vacated']
        }
    }

    let infoContent = '';
    infoTextArray.forEach(function(infoText) {
        infoContent += '<div class="margin-bottom-7">— ' + infoText + '</div>'
    });
    return infoContent;
}

function showDraftResults(draft, fadeIn = true, endDraft = false) {
    let randomPickAnimationRunning = false;

    hideContent($());

    // Add brand draft info
    $('.draft-result-container').data('is-brand-draft', draft['isBrandDraft']);

    let isSingleColumn = false;
    if (draft['isBrandDraft'] || draft['type'] === 'user_only') {
        $('.draft-result-container').addClass('single-column');
        isSingleColumn = true;
    }
    else {
        $('.draft-result-container').removeClass('single-column')
    }

    // Draft result
    let draftResultHtml = getDraftResultHtml(draft['result'], draft['playerNames'], draft['brandColors'],
        isSingleColumn, draft['rosterCapacity']);

    // Draft header
    let draftHeaderHtml = '<div class="margin-bottom-30 font-mukta-mahee font-1p325em font-bold ' +
        'menu-header-color">' + draft['name'] + '</div>';

    // Draft buttons
    let draftButtonsHtml = '';
    let draftRandomPickAnimationInput = '';
    if (!endDraft) {
        if (!draft['ended']) {
            let skipPickButtonHtml = '';
            let simulatePicksButtonHtml = '';
            // Skip pick button for brand draft
            if (draft['isBrandDraft']) {
                skipPickButtonHtml = '<button type="button" ' +
                'class="button retro-button grey-button-background margin-right-5 margin-bottom-5 thin skip-draft-pick-button">' +
                'Skip Pick</button>'
            }
            // Simulate picks button
            else {
                simulatePicksButtonHtml = '<button type="button" ' +
                'class="button retro-button grey-button-background margin-right-5 thin ' +
                'simulate-draft-picks-button">' +
                'Simulate Picks</button>'
            }
            draftButtonsHtml = '<div>' +
                '<button type="button" ' +
                'class="button retro-button margin-right-5 margin-bottom-5 thin make-next-draft-pick-button">' +
                'Make Pick</button>' +
                '<button type="button" ' +
                'class="button retro-button orange-button-background margin-right-5 thin ' +
                'randomize-next-draft-pick-button">' +
                'Random Pick</button>' +
                simulatePicksButtonHtml +
                skipPickButtonHtml +
                '<button type="button" id="end-draft-turn-button" ' +
                'class="button retro-button thin red-button-background">End Turn</button>' +
                '</div>';
        }
        else {
            draftButtonsHtml =
                '<button type="button" id="end-draft-turn-button" ' +
                'class="button retro-button thin display-block">End Draft</button>' +
                '</div>';
            notie.alert({type: 4, text: 'All draft selections have been made'})
        }

        // Random pick animation checkbox
        let animationChecked = '';
        if (showRandomPickAnimation) {
            animationChecked = ' checked="checked"'
        }
        draftRandomPickAnimationInput = '<label class="control control--checkbox display-block medium-grey margin-bottom-20">' +
            '<input type="checkbox" value="show_random_pick_animation"' + animationChecked + ' autocomplete="off">Show Random Pick Animation' +
            '<div class="control__indicator"></div>' +
            '</label>';
    }

    // Add html, scroll to top of result picks
    let draftResultContainerHtml = draftHeaderHtml + draftResultHtml + draftRandomPickAnimationInput + draftButtonsHtml;
    $('.draft-result-container').html(draftResultContainerHtml);
    if (fadeIn) {
        $('.draft-result-container').fadeIn('fast');
    }
    else {
        $('.draft-result-container').show();
    }

    scrollToLatestPick(draft, endDraft);

    // Make pick button
    $(".draft-result-container").off('click', '.make-next-draft-pick-button, .next-draft-pick');
    $(".draft-result-container").on('click', '.make-next-draft-pick-button, .next-draft-pick', function () {
        if (randomPickAnimationRunning) {
            notie.alert({type: 4, text: "Please wait for the random pick to finish"});
            return false;
        }
        if (draft['picksData'].length <= 0) {
            notie.alert({type: 3, text: "There are no more Superstars available to be drafted"});
            return false;
        }
        let draftAvailablePicksHtml = getDraftAvailablePicksHtml(draft);
        $('.draft-available-picks-container').html(draftAvailablePicksHtml);
        $(".draft-result-container").fadeOut('fast', function () {
            $('.draft-available-picks-container').fadeIn('fast');
            $('.draft-available-picks-box').scrollTop(0);
        });
    });

    // Show superstar info when clicking on draft pick superstar
    $(".draft-available-picks-container").off('click', '.draft-available-pick');
    $(".draft-available-picks-container").on('click', '.draft-available-pick', async function() {
        if ($(this).hasClass('disabled')) {
            return false;
        }
        let superstarUid = $(this).attr('data-uid');

        // Add selected
        $('.draft-available-pick').removeClass('selected');
        $(this).addClass('selected');

        $('.draft-available-pick-name div').removeClass('team-superstar');
        await makeGameRequest(getDraftSuperstarInfo, {superstarUid, draftUid: draft['uid']}, showGetDraftSuperstarInfoData,
            {}, false);
    });

    // Confirm draft pick
    $(".draft-available-picks-container").off('click', '#confirm-draft-pick-button');
    $(".draft-available-picks-container").on('click', '#confirm-draft-pick-button', async function() {

        // Get selected pick
        let selectedPick = $('.draft-available-pick.selected');
        if (selectedPick.length <= 0) {
            notie.alert({type: 3, text: "Select a Superstar to draft"});
            return false;
        }

        // Check if superstar is protected
        if (selectedPick.hasClass('unavailable')) {
            notie.alert({type: 3, text: "This Talent is protected by their Company and cannot be drafted"});
            return false;
        }

        // Get function to call
        let functionToCall;
        if ($('.draft-result-container').data('is-brand-draft')) {
            functionToCall = addBrandDraftPick;
        }
        else {
            functionToCall = addUserDraftPick;
        }

        let superstarUid = selectedPick.attr('data-uid');
        await makeGameRequest(functionToCall, {superstarUid, draftUid: draft['uid']}, showUserPickData, {}, false);
    });

    // Back to draft result
    $(".draft-available-picks-container").off('click', '#back-to-draft-result-button');
    $(".draft-available-picks-container").on('click', '#back-to-draft-result-button', function () {
        $('.draft-available-picks-container').fadeOut('fast', function () {
            $('.draft-result-container').fadeIn('fast');
            $('#booking-container').hide();
            scrollToLatestPick(draft, endDraft);
        })
    });

    // Draft search
    $(".draft-available-picks-container").off('input', '.draft-available-picks-search-input');
    $(".draft-available-picks-container").on('input', '.draft-available-picks-search-input', function(){
        runDraftSuperstarsSearch();
    });

    // Random pick button
    $(".draft-result-container").off('click', '.randomize-next-draft-pick-button');
    $(".draft-result-container").on('click', '.randomize-next-draft-pick-button', async function () {

        if (randomPickAnimationRunning) {
            notie.alert({type: 4, text: "Please wait for the random pick to finish"});
            return false;
        }
        if (draft['picksData'].length <= 0) {
            notie.alert({type: 3, text: "There are no more Superstars available to be drafted"});
            return false;
        }

        // Get function to call
        let functionToCall;
        if ($('.draft-result-container').data('is-brand-draft')) {
            functionToCall = addBrandDraftPick;
        }
        else {
            functionToCall = addUserDraftPick;
        }

        await makeGameRequest(functionToCall, {draftUid: draft['uid'], random: true}, showRandomPickData, {}, false);

        function showRandomPickData({data} = {}) {
            if (showRandomPickAnimation) {
                randomPickAnimationRunning = true;
                let nextPickElement = $('.draft-result-container .next-draft-pick .draft-result-roster-pick-name');
                let picks = shuffle(data['picksData']);
                let j = 0;
                let k = 0;
                let showAvailableDraftPicks = setInterval(function () {
                    // Get next draft pick from randomized array
                    nextPickElement.text(picks[j]);
                    j++;
                    if (j >= picks.length) {
                        j = 0
                    }
                    k++;
                    if (k >= 26) {
                        nextPickElement.text(data['randomPick']);
                        clearInterval(showAvailableDraftPicks);
                        setTimeout(function () {
                            showUserPickData({data, fadeIn: false});
                            randomPickAnimationRunning = false;
                        }, 450);
                    }
                }, 115, k);
            }
            else {
                showUserPickData({data, fadeIn: false});
            }
        }
    });

    // Simulate picks button
    $(".draft-result-container").off('click', '.simulate-draft-picks-button');
    $(".draft-result-container").on('click', '.simulate-draft-picks-button', function () {
        if (randomPickAnimationRunning) {
            notie.alert({type: 4, text: "Please wait for the random pick to finish"});
            return false;
        }
        notie.confirm({
            text: 'Are you sure you want to Simulate Picks for the Draft? All remaining picks will be simulated.',
            submitCallback: async function () {
                await makeGameRequest(simulateDraftPicks, {draftUid: draft['uid']}, showUserPickData, {fadeIn: false}, false);
            }
        });
    });

    // End draft button
    $(".draft-result-container").off('click', '#end-draft-turn-button');
    $(".draft-result-container").on('click', '#end-draft-turn-button', function () {
        if (randomPickAnimationRunning) {
            notie.alert({type: 4, text: "Please wait for the random pick to finish"});
            return false;
        }
        notie.confirm({
            text: 'Are you sure you want to end this turn?',
            submitCallback: async function () {
                let functionToCall;
                if ($('.draft-result-container').data('is-brand-draft')) {
                    functionToCall = endBrandDraftTurn
                }
                else {
                    functionToCall = endDraftTurn
                }
                await makeGameRequest(functionToCall, {draftUid: draft['uid']}, showEndDraftData, {}, false);
            }
        });
    });

    // Skip draft pick button
    $(".draft-result-container").off('click', '.skip-draft-pick-button');
    $(".draft-result-container").on('click', '.skip-draft-pick-button', async function () {
        if (randomPickAnimationRunning) {
            notie.alert({type: 4, text: "Please wait for the random pick to finish"});
            return false;
        }
        await makeGameRequest(skipBrandDraftTurn, {draftUid: draft['uid']}, showUserPickData, {fadeIn: false}, false);
    });

    // Enable/disable random pick animation
    $(".draft-result-container").off('change', 'input[value="show_random_pick_animation"]');
    $(".draft-result-container").on('change', 'input[value="show_random_pick_animation"]', function () {
        showRandomPickAnimation = !!$(this).prop('checked');
    });

    // Scroll roster pick boxes together
    if (!endDraft) {
        let divs = document.getElementsByClassName('draft-result-roster-picks');
        let syncing = new Array(divs.length).fill(false);
        [].forEach.call(divs, function (div, i) {
            div.onscroll = function () {
                let $this = this;
                if (!syncing[i]) {
                    // Scroll other elements
                    [].forEach.call(divs, function (otherDiv, j) {
                        if ($this !== otherDiv) {
                            syncing[j] = true;
                            otherDiv.scrollTop = $this.scrollTop;
                        }
                    });
                }
                // Element synced, don't run scroll function again
                syncing[i] = false;
            }
        });
    }
}

function scrollToLatestPick(draft, endDraft) {
    // Scroll to latest pick
    $('.draft-result-roster-picks').scrollTop(0);

    $('.draft-result-roster-picks').each(function (i, el) {

        // If roster/brand active in draft or ending draft or showing simulation results (no rosters/brands present in draft)
        let keyName = $(el).siblings('.draft-result-roster-name').attr('data-name');
        let draftObjects = (draft['isBrandDraft']) ? draft['brands'] : draft['rosters'];
        let draftCurrentPick = (draft['currentPickBrand']) ? draft['currentPickBrand'] : draft['currentPickCompany'];
        if (draftObjects.indexOf(keyName) >= 0 || endDraft || draftObjects.length === 0) {

            // Scroll to current pick's next empty pick
            let picksMade = $(el).find('.draft-result-roster-pick:not(:contains("Empty"))').length;
            if ((keyName === draftCurrentPick || draft['ended']) && picksMade > 4) {
                let scrollToIndex = picksMade - 4;
                if (endDraft) {
                    scrollToIndex = -3
                }
                let latestPickElement = $(el).find('.draft-result-roster-pick:not(:contains("Empty"))').eq(scrollToIndex);
                if (latestPickElement.length > 0) {
                    latestPickElement[0].scrollIntoView();
                }
            }
            if (keyName === draftCurrentPick) {
                $(el).parent()[0].scrollIntoView();
            }

            if (!endDraft) {
                // Highlight next pick
                let nextEmptyDiv = $(el).find('.draft-result-roster-pick:contains("Empty"):first');
                nextEmptyDiv.find('.draft-result-roster-pick-name').removeClass('extra-light-grey').addClass('light-grey');

                // Add next pick button to user company's next pick
                if (!draft['ended']) {
                    if (keyName === draftCurrentPick) {
                        nextEmptyDiv.addClass('next-draft-pick background-pulse')
                    }
                }
            }
        }
    });
}

function getDraftResultHtml(resultData, playerData, brandColors, isSingleColumn, rosterCapacity) {
    let html = '';
    if (!isSingleColumn) {
        html = '<div class="draft-result-items-container margin-bottom-10">'
    }

    // Draft results
    Object.keys(resultData).forEach(function(name) {
        // Add player name if local multiplayer
        let playerName;
        if (globals.game.controlMultipleCompanies && playerData) {
            playerName = (playerData[name]) ? playerData[name] : 'CPU'
        }
        let brandColor;
        if (brandColors) {
            brandColor = brandColors[name];
        }

        let keyPicks = resultData[name];
        let draftResult = getKeyDraftResult(name, keyPicks, playerName, brandColor, isSingleColumn, rosterCapacity);
        html += draftResult;
    });
    if (!isSingleColumn) {
        html += '</div>';
    }

    return html;
}

function getKeyDraftResult(name, picks, playerName, brandColor, isSingleColumn, rosterCapacity) {
    let picksHtml = getDraftPicksHtml(picks, isSingleColumn);

    // Get player name
    let playerNameHtml = '';
    if (playerName) {
        playerNameHtml = '<div class="draft-result-roster-player-name light-grey margin-top-3 line-height-1p4 text-center">' +
            '<div>' + playerName + '</div>' +
            '</div>'
    }

    // Get brand color
    let brandNameStyleHtml = '';
    if (brandColor && !globalUser.settings.colorblindMode) {
        brandNameStyleHtml = ' style="color: ' + brandColor + '"';
    }

    // Show roster capacity
    let rosterCapacityInfo = '';
    if (rosterCapacity) {
        let rosterSizeClass;
        if (picks.length === rosterCapacity) {
            rosterSizeClass = 'dark-yellow';
        } else {
            rosterSizeClass = 'light-green';
        }
        rosterCapacityInfo = '<span class="float-right ' + rosterSizeClass + '">' + picks.length +
            '<span class="margin-left-2 margin-right-2">/</span>' + rosterCapacity + '</span>';
    }

    return '<div class="draft-result-roster-box">' +
        '<div class="draft-result-roster-name medium-dark-grey line-height-1p4 text-center" data-name="' + name.replace(/"/g, "&quot;") + '">' +
        '<div' + brandNameStyleHtml + '>' + name + rosterCapacityInfo + '</div>' +
        '</div>' +
        playerNameHtml +
        '<div class="draft-result-roster-picks margin-top-10">' +
        '<div>' + picksHtml + '</div>' +
        '</div>' +
        '</div>';
}

function getDraftPicksHtml(picks, isSingleColumn) {
    let html = '';

    picks.forEach(function(pick, index) {
        let pickHtml = getDraftPickHtml(pick, index, false, isSingleColumn);
        html += pickHtml;
    });

    // Show empty picks (total picks become rounded to next ten)
    for (let i = picks.length; i < Math.ceil((picks.length + 3) / 10) * 10; i++) {
        let pickHtml = getDraftPickHtml('Empty', i, true);
        html += pickHtml;
    }

    return html;
}

function getDraftPickHtml(pick, index, empty, isSingleColumn) {
    let order = index + 1;
    let ordinalIndicator = getOrdinalIndicator(order);
    let pickClass = (empty) ? ' extra-light-grey' : '';

    let nameMaxLimit = (isSingleColumn) ? 35 : 15;
    let name = getShortenedName(pick, nameMaxLimit, true);

    let helpClass = '';
    let titleHtml = '';
    if (name !== pick) {
        helpClass = ' help-text';
        titleHtml = ' title="' + pick.replace(/"/g, "&quot;") + '"';
    }

    let numberText = order;
    if (order < 100) {
        numberText += ordinalIndicator
    }

    return '<div class="draft-result-roster-pick">' +
        '<div class="draft-result-roster-pick-number medium-light-grey margin-right-8">' + numberText + '</div>' +
        '<div class="draft-result-roster-pick-name' + pickClass + helpClass + '"' + titleHtml + '>'
        + name.replace(/"/g, "&quot;") + '</div>' +
        '<div class="clear"></div>' +
        '</div>';
}

function getOrdinalIndicator(number) {
    let tensRemainder = number % 10,
        hundredsRemainder = number % 100;
    if (tensRemainder === 1 && hundredsRemainder !== 11) {
        return "st";
    }
    if (tensRemainder === 2 && hundredsRemainder !== 12) {
        return "nd";
    }
    if (tensRemainder === 3 && hundredsRemainder !== 13) {
        return "rd";
    }
    return "th";
}

function getDraftAvailablePicksHtml(draftData) {
    let html = '';
    let draftCurrentPick = (draftData['currentPickBrand']) ? draftData['currentPickBrand'] : draftData['currentPickCompany'];
    let draftCurrentPickHtml = '<div class="light-grey margin-top-2 font-arial font-16px">' + draftCurrentPick + '\'s Turn</div>';

    // Header
    html += '<div class="margin-bottom-30 font-mukta-mahee font-1p325em font-bold ' +
        'menu-header-color">Available Picks' + draftCurrentPickHtml + '</div>';

    // Search
    html += '<div class="draft-available-picks-search-container margin-bottom-15">' +
        '<input type="text" name="draft-available-picks-search-input" placeholder="Search"' +
        ' autocomplete="off" class="styled-input draft-available-picks-search-input remove-outline">' +
        '</div>';

    // Available picks
    let availablePicksListHtml = getAvailablePicksListHtml(draftData['picksData']);
    html += availablePicksListHtml;

    // Confirm/back buttons
    html += '<div class="margin-top-25">' +
        '<button type="button" id="confirm-draft-pick-button" ' +
        'class="button retro-button button-background margin-right-8 thin">' +
        'Confirm</button>' +
        '<button type="button" id="back-to-draft-result-button" ' +
        'class="button retro-button thin grey-button-background">Back</button>' +
        '</div>';

    return html;
}

function getAvailablePicksListHtml(data) {
    let picksHtml = '';
    data.forEach(function(superstar) {
        picksHtml += getAvailablePickHtml(superstar)
    });
    return '<div class="draft-available-picks-box margin-bottom-20">' +
        picksHtml +
        '</div>';
}

function getAvailablePickHtml(superstar) {
    let popularity = '<span class="margin-left-15">' + superstar['popularity'] + '</span>';
    let age = '<span class="margin-left-10 medium-light-grey">' + superstar['age'] + ' y/o</span>';

    // Superstar name, color and help text
    let superstarNameClass = '';
    let superstarHelpTexts = [];

    let unavailableClass = '';
    if (superstar['unavailable']) {
        unavailableClass = ' unavailable';
        superstarHelpTexts.push('Protected by Company');
    }
    if (superstar['partTimer']) {
        superstarNameClass = 'blue';
        superstarHelpTexts.push('Part-timer')
    }
    if (superstar['injured']) {
        superstarNameClass = 'dark-red';
        superstarHelpTexts.push('Injured');
    }
    if (superstar['retired']) {
        superstarNameClass = 'light-grey';
        superstarHelpTexts.push('Retired');
    }
    if (superstar['fullTimeManager']) {
        superstarNameClass = 'manager-color';
        superstarHelpTexts.push('Full-time Manager');
    }
    if (superstar['championships'].length > 0) {
        superstarNameClass = 'gold';
        let championships = Array.from(superstar['championships'], function(championship) {return championship + ' Champion'});
        superstarHelpTexts.push(commaSeparate(championships));
    }

    let superstarName;
    if (superstarHelpTexts.length > 0) {
        superstarName = '<div class="line-height-1p4 ' + superstarNameClass +
            ' help-text display-inline-block" title="' + superstarHelpTexts.join(', ') + '">' + superstar['name']  +
            '</div>'
    }
    else if (superstarNameClass) {
        superstarName = '<div class="line-height-1p4 display-inline-block' +
            superstarNameClass + '">' + superstar['name']  + '</div>'
    }
    else {
        superstarName = '<div class="line-height-1p4 display-inline-block">' +
            superstar['name'] + '</div>'
    }

    return '<div class="inner-box-item draft-available-pick' + unavailableClass + '" data-uid="' + superstar['uid'] +
        '" data-name="' + superstar['name'].replace(/"/g, "&quot;") + '">' +
        '<div class="draft-available-pick-name">' +
        superstarName +
        '</div>' +
        '<div class="draft-available-pick-details">' +
        '<span>' +
        age + popularity +
        '</span>' +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>';
}

function runDraftSuperstarsSearch() {
    let availableSuperstarsContainer = $('.draft-available-picks-box');
    let availableSuperstarsElements = $('.draft-available-pick:not(.no-draft-search-results)');
    let searchTerm = $(".draft-available-picks-search-input").val();
    availableSuperstarsElements.hide();

    // Run search
    if (searchTerm.length > 0) {
        let searchResults = runFuseElementsSearch(availableSuperstarsElements, searchTerm, ['textContent']);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function (e) {
                $(e).show()
            });
            $('.no-draft-search-results').hide();
        }
        else {
            if ($('.no-draft-search-results').length > 0) {
                $('.no-draft-search-results').show()
            }
            else {
                availableSuperstarsContainer.append('<div class="no-draft-search-results inner-box-item ' +
                    'draft-available-pick disabled light-grey">No Results Found</div>')
            }
        }
    }
    else {
        availableSuperstarsElements.show();
        $('.no-draft-search-results').hide();
    }

    availableSuperstarsContainer.scrollTop(0);
    availableSuperstarsContainer[0].scrollIntoView();
}

function showGetDraftSuperstarInfoData({data} = {}) {
    showSuperstarInformation(data, false, false, true, true);
    data['teamSuperstars'].forEach(function (participant) {
        let elementsFound = $('.draft-available-pick')
            .filter(function () {
                return $(this).data("name") === participant;
            });
        elementsFound.find('.draft-available-pick-name div').addClass('team-superstar');
    });
}

function showUserPickData({data, fadeIn} = {}) {
    if (!data['error']) {
        // Show draft results
        $(".draft-available-picks-container").fadeOut('fast', function () {
            showDraftResults(data['draftData'], fadeIn);
        });
    }
    else {
        let errorText;
        if (data['error'] === 'superstar-not-found') {
            errorText = 'That Superstar could not be found. Please try again.'
        }
        else if (data['error'] === 'superstar-not-available') {
            errorText = 'That Superstar is not available to be drafted.'
        }
        else if (data['error'] === 'not-user-turn') {
            errorText = 'It wasn\'t your turn to draft a Superstar.'
        }
        else if (data['error'] === 'max-capacity') {
            errorText = 'Your Roster Capacity does not allow more than ' + data['capacity'] + ' active Superstars'
        }
        else if (data['error'] === 'no-superstars-available') {
            errorText = 'There are no more Superstars available to be drafted'
        }
        notie.alert({type: 3, text: errorText});
    }
}

async function showEndDraftData({data} = {}) {
    if (!data['error']) {
        // Show draft results
        showDraftResults(data['draftData'], false, data['draftData']['ended']);

        if (data['draftData']['ended']) {
            // Hide draft container, load home page
            setTimeout(function () {
                $(".draft-result-container").fadeOut('fast', async function () {
                    await loadHomePage(await getCurrentGame());
                });
            }, 2500);

            notie.alert({type: 4, text: data['draftData']['name'] + ' has ended'});

            // Enable menu buttons
            resetMenuButtonClickHandlers('default');
        }
    } else {
        if (data['error'] === 'minimum-picks') {
            notie.alert({
                type: 3, text: 'You need to make a minimum of ' + data['minimumPicks'] + ' picks in the Draft',
                stay: true
            });
        }
    }
}

export {showDraftPage}